module.exports = __webpack_public_path__ + "static/media/Panic_attack.a51a0202.jpg";